import { render, staticRenderFns } from "./ProfileFeeEnableModal.vue?vue&type=template&id=664dbc76"
import script from "./ProfileFeeEnableModal.vue?vue&type=script&lang=js"
export * from "./ProfileFeeEnableModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports